<template>
  <div class="product-detail-page-6">
    <!-- 商品总的描述 -->
    <div class="top-section flex-between">
      <!-- 左边主要内容 -->
      <div class="left-content flex-rowl">
        <div class="image-container">
          <img
            src="https://upload.vwingist.com/melscn/0image/2025/04/4990238919937414802.jpg"
            class="zoomable-image"
          />
        </div>
        <div class="text-content">
          <h1 class="title">{{ $t('productDetail6.title') }}</h1>
          <h2 class="sub_title">{{ $t('productDetail6.subTitle') }}</h2>
          <div class="description">
            <p class="txt2 mb_30" v-html="$t('productDetail6.description.para1')"></p>
            <p class="txt2 mb_40" v-html="$t('productDetail6.description.para2')"></p>
            <p class="txt1 mb_30">{{ $t('productDetail6.description.usageTitle') }}</p>
            <p class="txt2" v-html="$t('productDetail6.description.usageContent')"></p>
          </div>
          <div
            class="more-details-wrap"
            @mouseenter="showQRCode = true"
            @mouseleave="showQRCode = false"
          >
            <button class="more-details-btn flex-rowl">
               {{ $t('productDetail6.consultationButton') }}
              <i class="iconfont icon-xiangxiajiantou"></i>
            </button>
            <div class="more-details-ercode flex-colc" v-show="showQRCode">
              <div class="ercode_img">
                <img
                  src="https://upload.vwingist.com/melscn/0image/2025/05/5720379663789266597.png"
                  alt=""
                />
              </div>
              <div class="ercode_txt flex-colc">
                <p v-html="$t('productDetail6.qrCodeInfo.text1')"></p>
                <p v-html="$t('productDetail6.qrCodeInfo.text2')"></p>
                <p>{{ $t('productDetail6.qrCodeInfo.text3') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 右边商品分类折叠面板 -->
      <ProductCategoryPanel />
    </div>
    <!-- 商品详细描述 -->
    <div class="bottom-section">
      <div
        v-for="(item, index) in detailItems"
        :key="index"
        :class="[
          'bottom-section-list flex-between',
          item.length == 2 ? 'new-class-2' : '',
          item.length == 3 ? 'new-class-3' : '',
        ]"
      >
        <div
          class="detail-item"
          v-for="(itemChild, indexChild) in item"
          :key="indexChild"
        >
          <div class="top-part flex-between">
            <div class="left-text">
              <h2 class="sub-title">{{ $t(`productDetail6.detailItems[${indexChild}].subTitle`) }}</h2>
              <p class="sub-description">{{ $t(`productDetail6.detailItems[${indexChild}].subDescription`) }}</p>
            </div>
            <div class="right-image image-container">
              <img :src="itemChild.imageUrl" class="zoomable-image" />
            </div>
          </div>
          <div class="bottom-part">
            <h3 class="detail-title" v-html="$t(`productDetail6.detailItems[${indexChild}].detailTitle`)"></h3>
            <p
              class="detail-description"
              v-html="$t(`productDetail6.detailItems[${indexChild}].detailDescription`)"
            ></p>
          </div>
        </div>
      </div>
    </div>

    <!--  -->
    <div class="group-layout-container">
      <h1>{{ $t('productDetail6.groupLayout.title') }}</h1>
      <div class="group-layout flex-between">
        <div class="group-layout-list" v-for="(item, index) in groupLayout" :key="index">
          <div class="group-layout-item flex-between" v-for="(itemChild, indexChild) in item" :key="indexChild">
            <div class="left-text">
              <h2 class="sub-title">{{  $t(`productDetail6.groupLayout.items[${index}][${indexChild}].subTitle`) }}</h2>
              <p class="sub-description">{{  $t(`productDetail6.groupLayout.items[${index}][${indexChild}].subDescription`) }}</p>
            </div>
            <div class="right-image image-container">
              <img
                :src="itemChild.url"
                class="zoomable-image"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductCategoryPanel from "@/components/ProductCategoryPanel.vue";

export default {
  name: "ProductDetail1",
  components: {
    ProductCategoryPanel,
  },
  data() {
    return {
      showQRCode: false,
      detailItems: [
        [
          {
            subTitle: "角鲨烷",
            subDescription: "肌肤的天然盾牌 ",
            imageUrl:
              "https://upload.vwingist.com/melscn/0image/2025/03/5716467353162587659.png",
            detailTitle: "天然的“保护层”皮脂膜",
            detailDescription:
              "角鲨烷，这个与人体皮脂中的角鲨烯几乎一模一样的成分，能够在您的肌肤表层形成一层天然的“保护层”皮脂膜。它像一位智慧的向导，帮助您的肌肤抵御外界的刺激，锁住水分，让您的肌肤时刻保持滋润。",
          },
          {
            subTitle: "以油養膚",
            subDescription: "解鎖凍齡肌密",
            imageUrl:
              "https://upload.vwingist.com/melscn/0image/2025/03/4823314863924508211.png",
            detailTitle: "你的第二层肌肤，<br/>这不仅仅是一个口号",
            detailDescription:
              "VESCOR赋颜菁萃精华油，以油养肤，让肌肤润弹充盈，焕发自然光泽。它不仅能够提亮肤色、减少皱纹、修复受损肌肤屏障，还能快速补水、紧致肌肤、改善肌肤光滑度。",
          },
        ],
      ],
      groupLayout: [
        [
          {
            subTitle: "提亮肌膚",
            subDescription: "讓肌膚煥發光彩。",
            url: 'https://upload.vwingist.com/melscn/0image/2025/03/5109845810712253011.png'
          },
          {
            subTitle: "快速補水",
            subDescription: "讓肌膚水嫩動人",
            url: 'https://upload.vwingist.com/melscn/0image/2025/03/5539493041775134332.png'
          }
        ],
        [
          {
            subTitle: "減少皺紋",
            subDescription: "撫平歲月的痕跡",
            url: 'https://upload.vwingist.com/melscn/0image/2025/03/5064201436318448329.png'
          },
          {
            subTitle: "緊緻肌膚",
            subDescription: "塑造緊緻輪廓",
            url: 'https://upload.vwingist.com/melscn/0image/2025/03/4822137498443673996.png'
          }
        ],
        [
          {
            subTitle: "修補受損肌膚",
            subDescription: "重建肌膚的防禦牆",
            url: 'https://upload.vwingist.com/melscn/0image/2025/03/5213346728219124740.png'
          },
          {
            subTitle: "改善肌膚光滑",
            subDescription: "讓肌膚如絲般滑順",
            url: 'https://upload.vwingist.com/melscn/0image/2025/03/4827555569441315683.png'
          }
        ]
      ]
    };
  },
};
</script>

<style scoped lang="less">
.product-detail-page-6 {
  .image-container {
    display: inline-block; /* 确保容器只占用图片的空间 */
    overflow: hidden; /* 隐藏超出容器的部分 */
  }
  .zoomable-image {
    transition: transform 0.3s ease; /* 添加过渡效果，使放大过程更平滑 */
    cursor: pointer;
    &:hover {
      transform: scale(1.07); /* 鼠标悬停时放大图片 */
    }
  }
  .top-section {
    margin-bottom: 120px;
    align-items: flex-start;
    .left-content {
      width: 985px;
      flex-shrink: 0;
      align-items: flex-start;
      .image-container {
        width: 389px;
        height: 613px;
        margin-right: 50px;
        img {
          width: 100%;
          height: auto;
        }
      }
      .text-content {
        flex: 1;
        color: #333333;
        .title {
          font-size: 26px;
          margin-bottom: 10px;
          font-family: "SourceHanSerifCN-Medium", sans-serif;
          font-weight: 600;
        }
        .sub_title {
          font-size: 24px;
          margin-bottom: 40px;
        }

        .description {
          .txt1 {
            font-size: 20px;
            font-family: "SourceHanSerifCN-Medium", sans-serif;
          }
          .txt2 {
            font-size: 18px;
            line-height: 30px;
            font-family: "SourceHanSerifCN-Light", sans-serif;
          }
          .mb_30 {
            margin-bottom: 30px;
          }
          .mb_40 {
            margin-bottom: 40px;
          }
        }

        .more-details-btn {
          width: 359px;
          height: 50px;
          border-radius: 0px 0px 0px 0px;
          border: 2px solid #000000;
          font-size: 16px;
          color: #000000;
          margin-top: 120px;
          cursor: pointer;
          position: relative;
          padding-left: 30px;
          box-sizing: border-box;
          background-color: #fff;
          .icon-xiangxiajiantou {
            position: absolute;
            right: 20px;
            font-size: 12px;
          }
        }
      }
    }
  }

  .bottom-section {
    .bottom-section-list {
      align-items: flex-start;
      &.new-class-2 {
        padding-left: 110px;
        padding-right: 110px;
        .detail-item {
          flex-shrink: 0;
          width: calc((100% - 100px) / 2);
        }
      }
      &.new-class-3 {
        margin-bottom: 100px;
        .detail-item {
          flex-shrink: 0;
          width: calc((100% - 100px) / 3);
        }
      }
      .detail-item {
        padding-right: 47px;
        box-sizing: border-box;
        border-right: 1px dashed #999999;
        &:last-child {
          border-right: none;
        }
        .top-part {
          width: 370px;
          height: 150px;
          background: #f9f9f9;
          box-shadow: inset 0px 0px 16px 1px rgba(84, 79, 90, 0.1);
          border-radius: 75px 75px 75px 75px;
          margin-bottom: 50px;
          padding: 0 2px 0 27px;
          box-sizing: border-box;
          .left-text {
            color: #333333;
            .sub-title {
              font-size: 30px;
              font-family: "SourceHanSerifCN-Medium", sans-serif;
              margin-bottom: 10px;
              font-weight: 600;
            }
            .sub-description {
              font-size: 24px;
              font-family: "SourceHanSerifCN-Medium", sans-serif;
            }
          }
          .right-image {
            width: 145px;
            height: 145px;
            // border: 5px solid #fff;
            border-radius: 50%;
            box-sizing: border-box;
          }
        }
        .bottom-part {
          color: #333333;
          .detail-title {
            font-size: 24px;
            line-height: 34px;
            margin-bottom: 30px;
            font-family: "SourceHanSerifCN-Medium", sans-serif;
          }
          .detail-description {
            font-size: 16px;
            line-height: 28px;
            font-family: "SourceHanSerifCN-Light", sans-serif;
          }
        }
      }
    }
  }

  .more-details-wrap {
    position: relative;
    .more-details-ercode {
      width: 378px;
      height: 408px;
      background: url(https://upload.vwingist.com/melscn/0image/2025/04/5425508493632964248.png)
        no-repeat center;
      background-size: cover;
      position: absolute;
      bottom: -9px;
      left: 340px;
      z-index: 9999;
      .ercode_img {
        width: 230px;
        height: 230px;
        margin-bottom: 38px;
      }
      .ercode_txt {
        font-size: 16px;
        color: #333333;
        p {
          margin-bottom: 10px;
          font-family: "SourceHanSansCN-Light", sans-serif;
          span {
            font-family: "SourceHanSansCN-Medium", sans-serif;
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }

  .group-layout-container {
    margin-top: 120px;
    h1 {
      font-size: 26px;
      color: #333333;
      font-family: "SourceHanSerifCN-Medium", sans-serif;
      font-weight: 600;
      margin-bottom: 50px;
    }
    .group-layout {
      .group-layout-list {
        position: relative;
        &::after {
          display: inline-block;
          content: "";
          width: 0;
          height: 248px;
          border: 1px dashed #999999;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: -47px;
        }
        &:last-child {
          &::after {
            border: none;
          }
        }
        .group-layout-item {
          min-width: 370px;
          height: 150px;
          background: #f9f9f9;
          box-shadow: inset 0px 0px 16px 1px rgba(84, 79, 90, 0.1);
          border-radius: 75px 75px 75px 75px;
          margin-bottom: 50px;
          padding: 0 2px 0 27px;
          box-sizing: border-box;
          position: relative;
          margin-bottom: 50px;
          &:last-child {
            margin-bottom: 0;
          }

          .left-text {
            color: #333333;
            flex: 1;
            .sub-title {
              font-size: 30px;
              font-family: "SourceHanSerifCN-Medium", sans-serif;
              margin-bottom: 10px;
              font-weight: 600;
            }
            .sub-description {
              font-size: 24px;
              font-family: "SourceHanSerifCN-Medium", sans-serif;
            }
          }
          .right-image {
            width: 145px;
            height: 145px;
            border: 5px solid #fff;
            border-radius: 50%;
            box-sizing: border-box;
          }
        }
      }
    }
  }
}
</style>